import * as yup from "yup";

import { validator as applicantDataValidator } from "./ApplicantData/validator";
import { validator as perpetratorDataValidator } from "./PerpetratorData/validator";

export const validator = yup.object({
  ...perpetratorDataValidator,
  ...applicantDataValidator,
});
